import React, { useEffect, useState } from 'react';

const HolidayNotice = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Fade in animation on mount
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div 
      className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
      style={{ willChange: 'opacity, transform' }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="relative overflow-hidden rounded-2xl shadow-lg">
          {/* Gradient Background */}
          <div 
            className="absolute inset-0 bg-gradient-to-br from-amber-50 via-orange-50 to-amber-100"
            style={{
              backgroundImage: 'linear-gradient(135deg, #FEF3C7 0%, #FED7AA 50%, #FEF3C7 100%)'
            }}
          />
          
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-orange-200/30 to-transparent rounded-full blur-2xl" />
          <div className="absolute bottom-0 left-0 w-40 h-40 bg-gradient-to-tr from-amber-200/30 to-transparent rounded-full blur-2xl" />
          
          {/* Content */}
          <div className="relative px-6 py-8 sm:px-10 sm:py-10">
            <div className="text-center">
              {/* Icon */}
              <div className="flex justify-center mb-4">
                <span className="text-4xl sm:text-5xl animate-pulse">🎄</span>
              </div>
              
              {/* Title */}
              <h2 className="text-2xl sm:text-3xl font-bold text-amber-900 mb-4">
                Holiday Season Update
              </h2>
              
              {/* Main Message */}
              <div className="max-w-2xl mx-auto space-y-4">
                <p className="text-base sm:text-lg text-amber-900 leading-relaxed">
                  Due to a high volume of submissions during the busy holiday season, 
                  processing times may take a little longer than usual.
                </p>
                
                <p className="text-base sm:text-lg text-amber-900 leading-relaxed">
                  We appreciate your patience! Our team is working diligently 
                  to ensure every order is verified and completed as quickly as possible.
                </p>
                
                <p className="text-base sm:text-lg text-amber-900 font-semibold leading-relaxed flex items-center justify-center gap-2">
                  Thank you for choosing us — we'll make sure your transactions 
                  are processed smoothly and promptly!
                  <span className="text-2xl">💫</span>
                </p>
              </div>
              
              {/* Decorative Bottom Line */}
              <div className="mt-6 flex items-center justify-center gap-2">
                <div className="h-px w-12 bg-gradient-to-r from-transparent to-amber-400" />
                <span className="text-amber-600 text-sm font-medium">We appreciate you</span>
                <div className="h-px w-12 bg-gradient-to-l from-transparent to-amber-400" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HolidayNotice;
